/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Origin_DescriptionInputs */

const en_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how to purchase Brave Origin, use it as an upgrade or standalone app, activate on other devices, and more.`)
};

const id_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari cara membeli Brave Origin, menggunakannya sebagai peningkatan atau aplikasi mandiri, mengaktifkan di device lain, dan banyak lagi.`)
};

const ms_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketahui cara membeli Brave Origin, menggunakannya sebagai naik taraf atau aplikasi kendiri, mengaktifkan pada peranti lain, dan banyak lagi.`)
};

const ca_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprèn com comprar Brave Origin, fer-lo servir com a actualització o aplicació independent, activar-lo en altres aparells, i molt més.`)
};

const cs_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zjistěte, jak zakoupit Brave Origin, použít jej jako upgrade nebo samostatnou aplikaci, aktivovat na dalších zařízeních a další.`)
};

const da_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær, hvordan du køber Brave Origin, bruger det som en opgradering eller en selvstændig app, aktiverer det på andre enheder og meget mere.`)
};

const de_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie, wie Sie Brave Origin kaufen, als Upgrade oder als eigenständige App verwenden, auf anderen Geräten aktivieren und mehr.`)
};

const et_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Õpi, kuidas osta Brave Origin, kasutada seda täiendusena või eraldiseisva rakendusena, aktiveerida teistes seadmetes ja palju muud.`)
};

const es_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprende cómo comprar Brave Origin, usarlo como actualización o aplicación independiente, activarlo en otros dispositivos y más.`)
};

const fr_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez comment acheter Brave Origin, l’utiliser comme mise à niveau ou application autonome, l’activer sur d’autres appareils, et bien plus encore.`)
};

const hr_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saznajte kako kupiti Brave Origin, koristiti ga kao nadogradnju ili samostalnu aplikaciju, aktivirati na drugim uređajima i još više.`)
};

const it_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri come acquistare Brave Origin, utilizzarlo come upgrade o app autonoma, attivarlo su altri dispositivi e altro ancora.`)
};

const lv_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzziniet, kā iegādāties Brave Origin, izmantot to kā jauninājumu vai atsevišķu lietotni, aktivizēt citās ierīcēs un daudz ko citu.`)
};

const lt_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sužinokite, kaip įsigyti Brave Origin, naudoti jį kaip atnaujinimą ar savarankišką programą, aktyvuoti kituose įrenginiuose ir kt.`)
};

const hu_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudd meg, hogyan vásárolhatsz Brave Origin-t, használhatod frissítésként vagy önálló alkalmazásként, aktiválhatod más eszközökön és még sok minden mást.`)
};

const nl_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek hoe je Brave Origin kunt kopen, gebruiken als upgrade of zelfstandige app, activeren op andere devices, en meer.`)
};

const nb_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær hvordan du kjøper Brave Origin, bruker det som en oppgradering eller frittstående app, aktiverer det på andre enheter og mer.`)
};

const pl_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz się, jak kupić Brave Origin, zacząć korzystać w ramach aktualizacji Brave lub jako samodzielnej aplikacji, aktywować na innych urządzeniach i nie tylko.`)
};

const pt_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba como comprar o Brave Origin, usá-lo como uma atualização ou aplicativo independente, ativá-lo em outros dispositivos e muito mais.`)
};

const ro_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Află cum să achiziționezi Brave Origin, să-l folosești ca upgrade sau ca aplicație de sine stătătoare, să-l activezi pe alte dispozitive și multe altele.`)
};

const sk_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zistite, ako zakúpiť Brave Origin, použiť ho ako upgrade alebo samostatnú aplikáciu, aktivovať na ďalších zariadeniach a viac.`)
};

const sl_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naučite se, kako kupiti Brave Origin, ga uporabljati kot nadgradnjo ali samostojno aplikacijo, ga aktivirati na drugih napravah in še več.`)
};

const fi_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opi, miten voit ostaa Brave Originin, käyttää sitä päivityksenä tai itsenäisenä sovelluksena, aktivoida sen muilla laitteilla ja paljon muuta.`)
};

const sv_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lär dig hur du köper Brave Origin, använder det som en uppgradering eller fristående app, aktiverar det på andra enheter med mera.`)
};

const vi_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hiểu cách mua Brave Origin, sử dụng nó như một bản nâng cấp hoặc ứng dụng độc lập, kích hoạt trên các thiết bị khác và hơn thế nữa.`)
};

const tr_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin'i nasıl satın alacağınızı, yükseltme veya bağımsız uygulama olarak nasıl kullanacağınızı, diğer cihazlarda nasıl etkinleştireceğinizi ve daha fazlasını öğrenin.`)
};

const el_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθετε πώς να αγοράσετε το Brave Origin, να το χρησιμοποιήσετε ως αναβάθμιση ή ως αυτόνομη εφαρμογή, να το ενεργοποιήσετε σε άλλες συσκευές και άλλα.`)
};

const bg_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Научете как да закупите Brave Origin, да го използвате като ъпгрейд или самостоятелно приложение, да го активирате на други устройства и още.`)
};

const ru_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнайте, как приобрести Brave Origin, использовать его в качестве обновления или отдельного приложения, активировать на других устройствах и многое другое.`)
};

const sr_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Научите како да купите Brave Origin, користите га као надоградњу или самосталну апликацију, активирате на другим уређајима и још много тога.`)
};

const uk_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дізнайтеся, як придбати Brave Origin, використовувати його як оновлення або самостійний додаток, активувати на інших пристроях тощо.`)
};

const ka_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გაიგეთ, როგორ შეიძინოთ Brave Origin, გამოიყენოთ ის როგორც განახლება ან დამოუკიდებელი აპლიკაცია, გაააქტიუროთ სხვა მოწყობილობებზე და მეტი.`)
};

const hi_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जानें कि Brave Origin कैसे खरीदें, इसे अपग्रेड या स्टैंडअलोन ऐप के रूप में कैसे उपयोग करें, अन्य डिवाइसों पर सक्रिय करें, और बहुत कुछ।`)
};

const th_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้วิธีการซื้อ Brave Origin, ใช้เป็นการอัปเกรดหรือเป็นแอปแบบสแตนด์อโลน, เปิดใช้งานบนอุปกรณ์อื่น และอื่นๆ`)
};

const ko_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin 구매 방법, 업그레이드 또는 단독 앱으로 사용하는 방법, 다른 디바이스에서 활성화하는 방법 등에 대해 알아보세요.`)
};

const zh_tw_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解如何購買 Brave Origin、將其作為升級或獨立應用程式使用、在其他裝置上啟用，以及更多資訊。`)
};

const ja_brave_origin_description = /** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Originの購入方法、アップグレードまたは単体アプリとしての使用、他のデバイスでのアクティベーションなどについてご紹介します。`)
};

/** @type {(inputs: Brave_Origin_DescriptionInputs) => LocalizedString} */
const zh_brave_origin_description = en_brave_origin_description;

/**
* | output |
* | --- |
* | "Learn how to purchase Brave Origin, use it as an upgrade or standalone app, activate on other devices, and more." |
*
* @param {Brave_Origin_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_origin_description = /** @type {((inputs?: Brave_Origin_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Origin_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_origin_description(inputs)
	if (locale === "ms") return ms_brave_origin_description(inputs)
	if (locale === "ca") return ca_brave_origin_description(inputs)
	if (locale === "cs") return cs_brave_origin_description(inputs)
	if (locale === "da") return da_brave_origin_description(inputs)
	if (locale === "de") return de_brave_origin_description(inputs)
	if (locale === "et") return et_brave_origin_description(inputs)
	if (locale === "es") return es_brave_origin_description(inputs)
	if (locale === "fr") return fr_brave_origin_description(inputs)
	if (locale === "hr") return hr_brave_origin_description(inputs)
	if (locale === "it") return it_brave_origin_description(inputs)
	if (locale === "lv") return lv_brave_origin_description(inputs)
	if (locale === "lt") return lt_brave_origin_description(inputs)
	if (locale === "hu") return hu_brave_origin_description(inputs)
	if (locale === "nl") return nl_brave_origin_description(inputs)
	if (locale === "nb") return nb_brave_origin_description(inputs)
	if (locale === "pl") return pl_brave_origin_description(inputs)
	if (locale === "pt") return pt_brave_origin_description(inputs)
	if (locale === "ro") return ro_brave_origin_description(inputs)
	if (locale === "sk") return sk_brave_origin_description(inputs)
	if (locale === "sl") return sl_brave_origin_description(inputs)
	if (locale === "fi") return fi_brave_origin_description(inputs)
	if (locale === "sv") return sv_brave_origin_description(inputs)
	if (locale === "vi") return vi_brave_origin_description(inputs)
	if (locale === "tr") return tr_brave_origin_description(inputs)
	if (locale === "el") return el_brave_origin_description(inputs)
	if (locale === "bg") return bg_brave_origin_description(inputs)
	if (locale === "ru") return ru_brave_origin_description(inputs)
	if (locale === "sr") return sr_brave_origin_description(inputs)
	if (locale === "uk") return uk_brave_origin_description(inputs)
	if (locale === "ka") return ka_brave_origin_description(inputs)
	if (locale === "hi") return hi_brave_origin_description(inputs)
	if (locale === "th") return th_brave_origin_description(inputs)
	if (locale === "ko") return ko_brave_origin_description(inputs)
	if (locale === "zh") return zh_brave_origin_description(inputs)
	if (locale === "zh-tw") return zh_tw_brave_origin_description(inputs)
	if (locale === "ja") return ja_brave_origin_description(inputs)
	return en_brave_origin_description(inputs)
});